import React from 'react';
import { CheckCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

interface IProps {
  tooltip?: string;
  onClick?: () => void;
  style?: React.CSSProperties | undefined;
  className?: string | undefined;
}

const CheckCircleIcon = ({ tooltip, onClick, style, className }: IProps) => {
  return (
    <Tooltip title={tooltip}>
      <CheckCircleOutlined
        onClick={onClick}
        style={{ color: '#52c41a', fontSize: 16, ...style }}
        className={className}
      />
    </Tooltip>
  );
};

export default CheckCircleIcon;
